export const CREATE_SAVED_SEARCH = 'CREATE_SAVED_SEARCH';
export const CREATE_SAVED_SEARCH_SUCCESS = 'CREATE_SAVED_SEARCH_SUCCESS';
export const CREATE_SAVED_SEARCH_FAILED = 'CREATE_SAVED_SEARCH_FAILED';

export const GET_SAVED_SEARCH = 'GET_SAVED_SEARCH';
export const GET_SAVED_SEARCH_SUCCESS = 'GET_SAVED_SEARCH_SUCCESS';
export const GET_SAVED_SEARCH_FAILED = 'GET_SAVED_SEARCH_FAILED';

export const GET_SAVED_SEARCH_RECENT = 'GET_SAVED_SEARCH_RECENT';
export const GET_SAVED_SEARCH_RECENT_SUCCESS = 'GET_SAVED_SEARCH_RECENT_SUCCESS';
export const GET_SAVED_SEARCH_RECENT_FAILED = 'GET_SAVED_SEARCH_RECENT_FAILED';

export const GET_SAVED_SEARCH_HISTORY = 'GET_SAVED_SEARCH_HISTORY';
export const GET_SAVED_SEARCH_HISTORY_SUCCESS = 'GET_SAVED_SEARCH__HISTORY_SUCCESS';
export const GET_SAVED_SEARCH_HISTORY_FAILED = 'GETGET_SAVED_SEARCH__HISTORY_FAILED_SAVED_SEARCH_FAILED';

export const CREATE_SAVED_SEARCH_DIRECTORY = 'CREATE_SAVED_SEARCH_DIRECTORY';
export const CREATE_SAVED_SEARCH_DIRECTORY_SUCCESS = 'CREATE_SAVED_SEARCH_DIRECTORY_SUCCESS';
export const CREATE_SAVED_SEARCH_DIRECTORY_FAILED = 'CREATE_SAVED_SEARCH_DIRECTORY_FAILED';

export const GET_SAVED_SEARCH_DIRECTORY = 'GET_SAVED_SEARCH_DIRECTORY';
export const GET_SAVED_SEARCH_DIRECTORY_SUCCESS = 'GET_SAVED_SEARCH_DIRECTORY_SUCCESS';
export const GET_SAVED_SEARCH_DIRECTORY_FAILED = 'GET_SAVED_SEARCH_DIRECTORY_FAILED';

export const GET_SAVED_SEARCH_DIRECTORIES = 'GET_SAVED_SEARCH_DIRECTORIES';
export const GET_SAVED_SEARCH_DIRECTORIES_SUCCESS = 'GET_SAVED_SEARCH_DIRECTORIES_SUCCESS';
export const GET_SAVED_SEARCH_DIRECTORIES_FAILED = 'GET_SAVED_SEARCH_DIRECTORIES_FAILED';

export const CHANGE_SAVED_SEARCH_DIRECTORY = 'CHANGE_SAVED_SEARCH_DIRECTORY';
export const CHANGE_SAVED_SEARCH_DIRECTORY_SUCCESS = 'CHANGE_SAVED_SEARCH_DIRECTORY_SUCCESS';
export const CHANGE_SAVED_SEARCH_DIRECTORY_FAILED = 'CHANGE_SAVED_SEARCH_DIRECTORY_FAILED';

export const DELETE_SAVED_SEARCH_DIRECTORY = 'DELETE_SAVED_SEARCH_DIRECTORY';
export const DELETE_SAVED_SEARCH_DIRECTORY_SUCCESS = 'DELETE_SAVED_SEARCH_DIRECTORY_SUCCESS';
export const DELETE_SAVED_SEARCH_DIRECTORY_FAILED = 'DELETE_SAVED_SEARCH_DIRECTORY_FAILED';

export const GET_SAVED_SEARCH_ID = 'GET_SAVED_SEARCH_ID';
export const GET_SAVED_SEARCH_ID_SUCCESS = 'GET_SAVED_SEARCH_ID_SUCCESS';
export const GET_SAVED_SEARCH_ID_FAILED = 'GET_SAVED_SEARCH_ID_FAILED';

export const DELETE_SAVED_SEARCH = 'DELETE_SAVED_SEARCH';
export const DELETE_SAVED_SEARCH_SUCCESS = 'DELETE_SAVED_SEARCH_SUCCESS';
export const DELETE_SAVED_SEARCH_FAILED = 'DELETE_SAVED_SEARCH_FAILED';

export const PATCH_SAVED_SEARCH = 'PATCH_SAVED_SEARCH';
export const PATCH_SAVED_SEARCH_SUCCESS = 'PATCH_SAVED_SEARCH_SUCCESS';
export const PATCH_SAVED_SEARCH_FAILED = 'PATCH_SAVED_SEARCH_FAILED';

export const MOVE_SAVED_SEARCH = 'MOVE_SAVED_SEARCH';
export const MOVE_SAVED_SEARCH_SUCCESS = 'MOVE_SAVED_SEARCH_SUCCESS';
export const MOVE_SAVED_SEARCH_FAILED = 'MOVE_SAVED_SEARCH_FAILED';

export const GET_SAVED_SEARCH_RESULT = 'GET_SAVED_SEARCH_RESULT';
export const GET_SAVED_SEARCH_RESULT_SUCCESS = 'GET_SAVED_SEARCH_RESULT_SUCCESS';
export const GET_SAVED_SEARCH_RESULT_FAILED = 'GET_SAVED_SEARCH_RESULT_FAILED';

export const SET_REDIRECT_SAVED_SEARCH = 'SET_REDIRECT_SAVED_SEARCH';
export const CLEAR_REDIRECT_SAVED_SEARCH = 'CLEAR_REDIRECT_SAVED_SEARCH';

export const CLEAR_SAVED_SEARCH_HISTORY = 'CLEAR_SAVED_SEARCH_HISTORY';
export const CLEAR_SAVED_SEARCH_HISTORY_SUCCESS = 'CLEAR_SAVED_SEARCH_HISTORY_SUCCESS';
export const CLEAR_SAVED_SEARCH_HISTORY_FAILED = 'CLEAR_SAVED_SEARCH_HISTORY_FAILED';

export const CLEAR_SAVED_SEARCH_DIRECTORY = 'CLEAR_SAVED_SEARCH_DIRECTORY';

